<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="手机号：">
            <el-input v-model="query.phone" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="全部" clearable size="small">
              <el-option v-for="(item,index) in technicalServiceLevel" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="全部" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['goods:classify:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['goods:classify:state']">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" row-key="id" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="技术老师姓名" prop="name" align="center" />
        <el-table-column label="身份" prop="identity" align="center"  />
        <el-table-column label="手机号" prop="phone" align="center" />
        <el-table-column label="图片" prop="promotionImg" align="center" >
          <template slot-scope="{row}">
            <el-image v-if="row.promotionImg && row.promotionImg !== '无'" style="width: 50px; height: 50px; border-radius: 50%" :src="row.promotionImg" :preview-src-list="[row.promotionImg]"></el-image>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center" >
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>{{row.state === 1 ? '启用' : '禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="createdTime" sortable="custom" align="center" width="180" />
        <el-table-column label="操作人" prop="operatorName" align="center" />
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <classify-add ref="classifyAdd" @created="doQueryList({})" :menuOptions="list" />
  </div>
</template>

<script>
import classifyAdd from './add'
import templateTeacherApi from '@/api/marketing/templateTeacher'
import Pagination from '@/components/Pagination'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNoSortSign: 1
      },
      selectItems: [],
      technicalServiceLevel: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    technicalServiceLevelApi.findOptions().then(({ data }) => {
      this.technicalServiceLevel = data
    })
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
      }
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'orderNo': 'orderNoSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = 0
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return templateTeacherApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择技术老师')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中技术老师批量启用？' : '确认将选中技术老师批量禁用？'
      this.$common.confirm(txt).then(() => {
        // TODO: 实现批量状态更新API
        this.$common.showMsg('info', '批量操作功能待实现')
        return this.doQueryList({ pageNo: 1 })
      })
    },
    changeSwitch(row) {
      templateTeacherApi.updateStateBatch({ ids: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.classifyShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row)
    },
    /**
     * 查看日志记录
     */
    handleLog(row) {
      this.$router.push("/log/log?type=123&id=" + row.id);
    }
  }
}
</script>
